import { render, staticRenderFns } from "./sharpness.vue?vue&type=template&id=2f7db07a&scoped=true"
import script from "./sharpness.vue?vue&type=script&lang=js"
export * from "./sharpness.vue?vue&type=script&lang=js"
import style0 from "./sharpness.vue?vue&type=style&index=0&id=2f7db07a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7db07a",
  null
  
)

export default component.exports